import {ActionType} from '@typescript/common/actionTypes';
import {PRODUCT} from 'constants/actions';

/**
 * Set collapsing state for collapsible block by name
 * @param {string} name - block name
 * @param {boolean} collapsed or not
 * @return {ActionType<{ name: string, collapsed: boolean }>} Action
 */
export function setCollapse(
    name: string,
    collapsed: boolean,
): ActionType<{name: string; collapsed: boolean}> {
    return {
        type: PRODUCT.SET_COLLAPSE,
        payload: {
            name,
            collapsed,
        },
    };
}
